<div class="mango-aws-s3-upload" style="padding: 20px;">
  <div class="header-upload">
    <div class="title-upload">
      <span>Upload Files</span>
    </div>

    <mango-list-view [selected]="selectedListView" (onSelected)="onSelectedHandle($event)"></mango-list-view>
  </div>

  <div class="mng-drap-drop-folder">
    <ngx-file-drop dropZoneLabel="Drag and drop files od folders"
                   (onFileDrop)="dropped($event)"
                   (onFileOver)="fileOver($event)"
                   (onFileLeave)="fileLeave($event)">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div class="upload-hint text-center" *ngIf="!files.length">
          <div><i class="fa fa-camera" aria-hidden="true"></i></div>
          <div>
            <small class="title-hint text-danger alert alert-danger" *ngIf="acceptedFilesType.length">
              Allowed Files:
              <strong *ngFor="let typeFile of acceptedFilesType; let i = index">
                {{ typeFile }} <span *ngIf="acceptedFilesType.length - 1 !== i">|</span>
              </strong>
            </small>
          </div>
          <div><span class="title-hint">Drag and drop files and folders here</span></div>
          <div class="title-hint">or choose</div>
          <label for="file-upload-{{ token }}" class="choose-add">Add file</label> or
          <label for="folder-upload-{{ token }}" class="choose-add">Add folders.</label>

          <!-- choose select file -->
          <input id="file-upload-{{ token }}" type="file" multiple (change)="onSelectFile($event)"
                 style="display: none;"/>

          <!-- choose select folder -->
          <input id="folder-upload-{{ token }}" type="file" multiple webkitDirectory (change)="onSelectFile($event)"
                 style="display: none;"/>
        </div>

        <div class="upload-hint text-center"
             *ngIf="files.length && !listSingleFilesPaginateUI.length && !listFilesFolderUI.length">
          <div><i class="fas fa-circle-notch fa-spin"></i></div>
          <div><span class="title-hint">processing data</span></div>
        </div>

        <div class="file-list" *ngIf="files.length">
          <!--        <div class="file-list">-->
          <div class="wrapper-grid" [ngClass]="{'inline-wrapper': selectedListView === 'list'}">

            <ng-container *ngFor="let item of listFilesFolderUI; let i = index">
              <div [ngClass]="{'inline-item': selectedListView === 'list'}">
                <mango-folder-upload
                  [data]="item"
                  [listView]="selectedListView"
                  [showMoreLimit]="showMoreLimit"
                ></mango-folder-upload>
              </div>
            </ng-container>

            <ng-container *ngFor="let item of listSingleFilesPaginateUI; let i = index">
              <div [ngClass]="{'inline-item': selectedListView === 'list'}" *ngIf="item.type !== 'mng-compressed'">
                <mango-item-upload
                  [data]="item"
                  [listView]="selectedListView"
                ></mango-item-upload>
              </div>
            </ng-container>

            <!--            <div class="item-more" [ngClass]="{'inline-item': selectedListView === 'list'}"-->
            <!--                 *ngIf="hasCompressed"-->
            <!--                 (click)="btnShowCompressedFiles()">-->
            <!--              <span>More ...</span>-->
            <!--            </div>-->

            <!--            <ng-container *ngFor="let item of listSingleFilesCompressedUI; let i = index">-->
            <!--              <div [ngClass]="{'inline-item': selectedListView === 'list'}">-->
            <!--                <mango-item-upload-->
            <!--                  [data]="item"-->
            <!--                  [listView]="selectedListView"-->
            <!--                ></mango-item-upload>-->
            <!--              </div>-->
            <!--            </ng-container>-->

          </div>
        </div>
      </ng-template>
    </ngx-file-drop>

    <div class="show-more"
         *ngIf="showMoreLimit && this.listSingleFilesUI.length && this.listSingleFilesUI.length > this.showMoreLimit">
      <button class="btn btn-primary btn-sm btn-block" (click)="btnShowMore()">Show More ...</button>
    </div>

    <div class="bottom-messages">
      <small *ngIf="isCompressing">
        Compress some files to upload
        <i class="fas fa-circle-notch fa-spin"></i>
      </small>
    </div>
  </div>

  <div class="global-progress" *ngIf="total > 0">
    <progressbar class="progress" [value]="stacked" [max]="100"></progressbar>
    <div>
      <span class="completed">
        <i class="fas fa-stop"></i>
        Completed ({{ completed }})
      </span>

      <!--      <span class="updating">-->
      <!--        <i class="fas fa-stop"></i>-->
      <!--        Updating (20)-->
      <!--      </span>-->

      <!--      <span class="processing">-->
      <!--        <i class="fas fa-stop"></i>-->
      <!--        Processing (20)-->
      <!--      </span>-->

      <span class="pending">
        <i class="fas fa-stop"></i>
        Pending ({{ pending }})
      </span>

      <span class="failed">
        <i class="fas fa-stop"></i>
        Failed (0)
      </span>
    </div>
  </div>

</div>
<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/css/all.min.css" rel="stylesheet">
